/**
 * @author Shilov Sergey <triglav86@gmail.com>, Max Erekhinskiy <max.erekhinskiy@gmail.com> Jun 28, 2012 11:51:23 AM
 * @copyright MegaGroup © 2012, megagroup.ru
 */

(function() {
	'use strict';

	var WSPoolingStatic = {
		isLong : true,

		packet : function (method, argv) {
			var WS = Onicon.transport.ws_instance;

			if(!WS) {
				Onicon.error('[transport.polling] Instance not exists, can not execute any method');
			} else {
				if(method in WS) {
					WS[method].call(WS, argv);
					if (typeof argv === 'object' && argv.code === 'close') Onicon.error(argv.message); // DEBUG ONLY
				} else {
					Onicon.error('[transport.polling] Method %s not exists in polling instace', method);
				}
			}
		}
	};

	var WSPooling = function (url, protocol) {
		var _id = null,
			_url = url,
			_self_name = 'Onicon.lib(\'transport.polling.static\').packet',
			_self = this,
			_counter = 0,

			_callBack = function (type, data) {
				if (_self[type] && _self[type].call) {
					if (type === 'onclose') {
						var close_timer = setInterval(function () {
							if (_counter <= 0) {
								clearInterval(close_timer);
								_self[type].call(_self, data);
							}
						}, 5);
					} else {
						_self[type].call(_self, data);
					}
				}
			},

			_addScript = function (query) {
				var rand = Math.round(Math.random() * 1000);
				var random_host = (_self.isLong ? (rand + '.') : '');
				Onicon.loader.script({
					url : _url.replace('http://', 'http://' + random_host) + '?' + query,
					wait : false,
					remove : true,
					cache : false,
					error : function() {
						_callBack('onclose');
					}
				});
			};

		this.stopConnection = function () {
			_addScript('j=stopConnection&id=' + _id);
		};

		this.setConnection = function (id) {
			if (typeof id !== 'string') {
				_callBack('onclose');
			} else {
				_id = id; // id.length === 32
				_callBack('onopen');
				//if (this.isLong) {
				//	_addScript('j=getPacket&id=' + _id);
				//}
				_addScript('j=getPacket&id=' + _id);
			}
		};

		this.getPacket = function (data) {
			switch (data.code) {
				case 'data':
					for (var i in data.data) {
						if (data.data.hasOwnProperty(i)) {
							_callBack('onmessage', {
								data      : data.data[i],
								timeStamp : new Date().getTime()
							});
						}
					}
					if (this.isLong) {
						_addScript('j=getPacket&id=' + _id);
					}
					break;
				case 'close':
					_callBack('onclose');
					break;
				//case 'die':
				case 'flush':
					break;
			}
		};

		this.setPacket = function (data) {
			if (/string|number/.test(typeof data)) {
				data += '';
				var mess_id = ++this.message_id;
				if (data.length) {
					var chunk = [],
						i = -1,
						length;
					data = data.split('');
					while (data.length) {
						chunk.push(encodeURIComponent(data.splice(0, 600).join('')));
					}
					length = chunk.length;
					while (chunk.length) {
						_addScript('j=setPacket&id=' + _id + '&mid=' + mess_id + '&no=' + (++i) + '&total=' + length +
							'&data=' + chunk.shift());
					}
					if (!this.isLong) {
						setTimeout(function () {
							_addScript('j=getPacket&id=' + _id);
						}, 200);
					}
				}
			} else if (data && data.code === 'close') {
				_callBack('onclose');
			}
		};

		this.onclose   = null;
		this.onerror   = null;
		this.onopen    = null;
		this.onmessage = null;

		this.CONNECTING = 0;
		this.OPEN       = 1;
		this.CLOSED     = 3;
		this.CLOSING    = 2;

		this.message_id = 0;

		this.readyState     = this.OPEN;
		this.bufferedAmount = 0;

		this.isLong = WSPoolingStatic.isLong;

		this.close = function () {
			_self.stopConnection();
		};
		this.send = function (data) {
			_self.setPacket(data);
		};

		_addScript('j=setConnection&' + (this.isLong ? '' : 'nl&') + 'global_name=' + _self_name);
	};

	Onicon.lib('transport.polling', WSPooling);
	Onicon.lib('transport.polling.static', WSPoolingStatic);
})();
